/** Paragraphs "changed" with no word that differs (only a space, or where they stand): the same. */
export function settled(entries) {
  return entries.map((e) => (e.state === 'changed' && !(e.parts || []).some((p) => p.type !== 'same' && p.text.trim()) ? { ...e, state: 'same' } : e))
}

/**
 * A text's change told briefly, for a timeline that stays short (D-348): the first `shown`
 * paragraphs that changed; in one changed, only the words about each change (`context` on each
 * side, the rest "…"); one added or gone cut at `max` characters. The whole stays a click away.
 *
 * @param {Array<{state: string, text: string, parts?: Array<{type: 'same'|'del'|'ins', text: string}>}>} entries compareDocs()
 * @returns {{lines: Array<{state: string, parts: Array<{type: string, text: string}>}>, more: number}}
 */
export function brief(entries, { shown = 2, context = 4, max = 140 } = {}) {
  const changed = settled(entries).filter((e) => e.state !== 'same')
  const cut = (text) => (text.length > max ? `${text.slice(0, max - 1).trimEnd()}…` : text)
  const lines = changed.slice(0, shown).map((e) => {
    if (e.state !== 'changed') return { state: e.state, parts: [{ type: e.state === 'added' ? 'ins' : 'del', text: cut(e.text || '') }] }
    const parts = e.parts || []
    return {
      state: 'changed',
      parts: parts.map((p, i) => {
        if (p.type !== 'same') return p
        const words = p.text.split(/(\s+)/)
        // Words, with the spaces between them kept: `context` real words of each side that touches a change.
        const real = words.filter((w) => w.trim()).length
        const first = i === 0
        const last = i === parts.length - 1
        const keep = (first ? 0 : context) + (last ? 0 : context)
        if (real <= keep + 2) return p
        const take = (list, n) => {
          const out = []
          let seen = 0
          for (const w of list) {
            if (seen >= n && w.trim()) break
            out.push(w)
            if (w.trim()) seen++
          }
          return out
        }
        const head = first ? [] : take(words, context)
        const tail = last ? [] : take([...words].reverse(), context).reverse()
        return { type: 'same', text: `${head.join('')}${head.length ? ' ' : ''}…${tail.length ? ' ' : ''}${tail.join('')}`.replace(/\s+…/, ' …').replace(/…\s+/, '… ') }
      }),
    }
  })
  return { lines, more: Math.max(0, changed.length - shown) }
}
